import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./auth/login";
import DashboardLayout from "./layout/dashBoradLayout";
import Dashboard from "./pages/Dashboard";
import Usuarios from "./pages/Usuarios";
import CrearUsuario from "./pages/CrearUsuario";
import Ebooks from "./pages/Ebooks";
import ProtectedRoute from "./utils/ProtectedRoute";
import CargaCsvUsuarios from "./pages/CargaDoc";
import CrearEbook from "./pages/CrearEbook";
import CargaStoragePdfNorma from "./pages/CargaNorma";
import UsuariosKootobe from "./pages/UsuariosKootobe";
import CargaNormaCSV from "./pages/CargaNormaCSV";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        {/* Todas las rutas del dashboard estarán protegidas */}
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="usuarios" element={<Usuarios />} />
          <Route path="usuarios/crear" element={<CrearUsuario />} />
          <Route path="ebook/crearEbook" element={<CrearEbook />} />
          <Route path="ebooks" element={<Ebooks />} />
          <Route path="cargadoc" element={<CargaCsvUsuarios />} />
          <Route path="ebook/cargaNorma" element={<CargaStoragePdfNorma />} />
          <Route path="UsuariosKootobe" element={<UsuariosKootobe />} />
          <Route path="ebook/cargaNormaCSV" element={<CargaNormaCSV />} />
        </Route>

        {/* Redirige cualquier otra ruta al login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
